import { createFileRoute } from '@tanstack/react-router';
import { SearchPage } from '../components/community/SearchPage';

export const Route = createFileRoute('/community/search')({
  component: SearchPage,
});
